import './SideNavModuleChildItem.scss';
import ClickableDiv from 'common/components/clickableDiv/ClickableDiv';
import { KWELLO_ICON, KwelloSvgIcon } from 'common/components/icon/KwelloSvgIcon';
import { useCompareUrlWithProjectId } from 'common/hooks/route';
import { MenuItem } from 'common/models/page-config.models';

interface SideNavModuleChildItemProps extends MenuItem {
  onClick: (item: MenuItem) => void;
}

function SideNavModuleChildItem(props: Readonly<SideNavModuleChildItemProps>) {
  const { onClick, ...item } = props;
  const { compareUrl } = useCompareUrlWithProjectId();

  const selected = compareUrl(item.route as string, { includes: true });

  return (
    <ClickableDiv
      id={item.id}
      className={`side-nav-module-child-item ${selected ? 'selected' : ''}`}
      onClick={() => props.onClick(props)}
    >
      {item.icon && (
        <div className="side-nav-icon">
          <KwelloSvgIcon icon={KWELLO_ICON[item.icon.toUpperCase() as keyof typeof KWELLO_ICON]} />
        </div>
      )}
      <div className="side-nav-module-item-text">
        {item.text} {item.tag && <span> - {item.tag}</span>}
      </div>
    </ClickableDiv>
  );
}

export default SideNavModuleChildItem;
